import { useQuery } from '@tanstack/react-query'

import { UsersService } from '../lib/users.service'

const PERMISSIONS_QUERY_KEY = 'user-permissions-key'

export const usePermissions = () =>
  useQuery({
    queryKey: [PERMISSIONS_QUERY_KEY],
    queryFn: () => UsersService.getPermissions(),
    select: data => data.data
  })
